export default "__VITE_ASSET__BeUD29xK__"